// extracted by mini-css-extract-plugin
export default {"message":"_gFTaX","invalid":"jBfybM"};